import { useCallback } from 'react';
import { coreDialogApi } from '@cp/entities/dialog';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { DialogMemberType } from '@common/model/dialog/dialogMemberType';
import { useApiServerErrorHandler } from 'src/shared/apiServer';

export const useCreateWithClient = () => {
  const handleApiServerError = useApiServerErrorHandler();
  const [create] = coreDialogApi.endpoints.createDialog.useMutation();

  return useCallback(
    async (clientId: ApiServerEntityIDType) => {
      const response = await create({ participantId: clientId, participantType: DialogMemberType.Client });

      if ('error' in response) {
        handleApiServerError(response.error);
        throw new Error();
      }

      return response.data;
    },
    [create, handleApiServerError],
  );
};
